import dhall from "refractor/dhall";
export default dhall;